/*
 * Design ID / Colorway style
 *
 **/
custom.typeDesignId = (() => {
  const productNameClass = 'js-product-name';
  const wallArtClass = 'js-wall-art-type';
  const rugPadClass = 'js-rug-pad-type';
  const poufClass = '.js-pouf';
  const OAKClass = 'One-of-a-Kinds';
  const initializedClass = 'type-design-id--initialized';

  function injectSpan(index = null, name = null) {
    if ($(name).hasClass(initializedClass)) return;
    $(name).addClass(initializedClass);

    const nameStr = custom.utils.titleCase($(name).text());
    if (
      ($(name).hasClass(wallArtClass) && !$(name).hasClass(OAKClass)) ||
      $(name).hasClass(rugPadClass)
    ) {
      return $(name).html(`${nameStr}`);
    } else {
      const firstSpaceIndex =
        nameStr.indexOf(' ') == -1 ? nameStr.length : nameStr.indexOf(' ');
      return $(name).html(
        '<span>' +
          nameStr.slice(0, firstSpaceIndex) +
          '</span>' +
          nameStr.slice(firstSpaceIndex),
      );
    }
  }

  const init = () => {
    if (!$(`.${productNameClass}`).length) return;
    $(poufClass).text($(poufClass).text().replace('Pf', 'PF'));
    $(poufClass).text($(poufClass).text().replace('Fp', 'FP'));
    $(`.${productNameClass}`).each((index, name) => {
      injectSpan(index, name);
    });
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/type-design-id.js